'use strict';

bbw.model.PostCollection = ngtk.model.List.extend({

    _itemModel: bbw.model.Post,

    _state: undefined,
    _loadArgs: undefined,
    
    _initialize: function() {
        this._items = {};
        this._itemsScopeData = [];
        this._state = {};
    },

    configure: function(cfg) {
        this._loadArgs = cfg;
        return this;
    },

    addCfg: function(cfg) {
        if (!this._loadArgs) {
            this._loadArgs = {};
        }
        angular.extend(this._loadArgs, cfg);
        return this;
    },

    load: function(cfg, more) {
        if (angular.isObject(cfg)) {
            if (angular.isObject(this._loadArgs)) {
                angular.extend(this._loadArgs, cfg);
            } else {
                this._loadArgs = cfg;
            }
        }
        if (!this._loadArgs) {
            throw new Error("Not configured");
        }
        return this._load(more);
    },

    loadMore: function() {
        return this._load(true);
    },

    getCount: function() {
        return this._count;
    },

    reload: function() {
        return this._load();
    },

    _load: function(more, limit) {
        var cfg = angular.copy(this._loadArgs);
        if (angular.isObject(this._state.next)) {
            if (more) {
                angular.extend(cfg, this._state.next);
            } else {
                this._state.next = undefined;
            }
        } else {
            if (more) {
                more = false;
            }
        }
        if (!more) {
            this._state.isLoadingInitial = true;
        }
        if (limit) {
            cfg.limit = limit;
        }
        return this._fetchViaApi(cfg).then(function(response) {
            this._updateStateFromResponse(response);
            this._setFromApiResult(response.posts.items, more);
            return more;
        }.bind(this)).finally(function() {
            delete this._state.isLoadingInitial;
        }.bind(this));
    },
    
    _fetchViaApi: function(cfg) {
        return this._loadFromApi('get', 'posts', cfg);
    },
    
    hasMore: function() {
        return this._state.hasMore;
    },

    _updateStateFromResponse: function(response) {
        ngtk.tools.object.replace(this._state, {
            count: response.posts.count,
            next: response.posts.next,
            hasMore: !!response.posts.has_more
        });
    },
    
    _updateItemsScopeData: function() {
        this._itemsScopeData.length = 0;
        angular.forEach(this._items, function(item) {
            item.wireScope(this._itemsScopeData, item.$$idx);
        }.bind(this));
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        if (angular.isUndefined(scopeInnerPtr[scopeInnerElement])) {
            scopeInnerPtr[scopeInnerElement] = {};
        }
        scopeInnerPtr[scopeInnerElement]['items'] = this._itemsScopeData;
        scopeInnerPtr[scopeInnerElement]['state'] = this._state;
        scopeInnerPtr[scopeInnerElement].$model = this;
    }

});